import { BASE_TIPPY_DIRECTIONS as e, TIPPY_STICKY_VALUES as t } from "../popover/tippy-utils.js";
//#region components/tooltip/tooltip_constants.js
var n = [...e], r = 300, i = {
	hover: "d-tooltip--hover",
	show: "d-tooltip--show",
	inverted: "d-tooltip--inverted",
	hide: "d-tooltip--hide"
}, a = [...t], o = [
	!0,
	!1,
	"toggle"
], s = {
	TOOLTIP_DIRECTIONS: n,
	TOOLTIP_DELAY_MS: 300,
	TOOLTIP_KIND_MODIFIERS: i,
	TOOLTIP_STICKY_VALUES: a,
	TOOLTIP_HIDE_ON_CLICK_VARIANTS: o
};
//#endregion
export { r as TOOLTIP_DELAY_MS, n as TOOLTIP_DIRECTIONS, o as TOOLTIP_HIDE_ON_CLICK_VARIANTS, i as TOOLTIP_KIND_MODIFIERS, a as TOOLTIP_STICKY_VALUES, s as default };

//# sourceMappingURL=tooltip-constants.js.map